"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_tv__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bf2339ea-2be1-48a2-8c89-5885cb8d852c",
    x1: 37,
    y1: 31,
    x2: 155,
    y2: 149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6f6f6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "06aa6258-acb6-4c5a-8063-aca62e27c6c2",
    "data-name": "TV_ic_hi",
    viewBox: "0 0 192 192"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "bc74e55e-f415-4db0-911b-a09c3d232f78",
    "data-name": "Bounding Box",
    points: "0 192 0 0 192 0 192 192 0 192",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 44,
    width: 160,
    height: 100,
    rx: 4,
    ry: 4,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,142H20a4,4,0,0,1-4-4v2a4,4,0,0,0,4,4H172a4,4,0,0,0,4-4v-2A4,4,0,0,1,172,142Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 46,
    width: 156,
    height: 88,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 48,
    width: 152,
    height: 84,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 48,
    width: 152,
    height: 84,
    opacity: 0.5,
    fill: "url(#bf2339ea-2be1-48a2-8c89-5885cb8d852c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.11,150h0A2,2,0,0,1,68,148h56.13a2,2,0,0,1,1.94,2h0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.11,
    y: 144,
    width: 20,
    height: 4,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163,
    cy: 138,
    r: 2,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "126.11 149.94 126.11 152 66.11 152 66.11 149.94",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.11,
    y: 150,
    width: 60,
    height: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 144,
    width: 20,
    height: 4,
    opacity: 0.06
  }))), /*#__PURE__*/React.createElement("title", null, "tv-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "0264f876-0540-4653-a93a-87382b268e2e",
    "data-name": "TV_ic"
  }, /*#__PURE__*/React.createElement("use", {
    id: "0a726c15-309c-49b6-ba21-28e08e11219f",
    "data-name": "TV_ic_hi",
    width: 192,
    height: 192,
    transform: "translate(0 0)",
    xlinkHref: "#06aa6258-acb6-4c5a-8063-aca62e27c6c2"
  })));
}

var _default = ic_tv__dark;
exports.default = _default;